/**
 * @file index.js
 * @author Alvaro Martinez
 * @description Initialize Blood Pressure View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './BloodPressureView';

export const mapStateToPropsBloodPressure = mapStateToProps;
export const mapDispatchToPropsBloodPressure = mapDispatchToProps;

export default connect(
  mapStateToPropsBloodPressure,
  mapDispatchToPropsBloodPressure
)(View);
